<template>
  <main class="main">
    <ol class="breadcrumb-trail__list">
      <li class="breadcrumb-trail__list--item">
        <router-link
          :to="{ path: `/${langPath}` }"
          class="breadcrumb-trail__list--item__link"
        >
          TOP
        </router-link>
      </li>
      <li class="breadcrumb-trail__list--item">
        <router-link
          :to="{ path: `/${langPath}question` }"
          class="breadcrumb-trail__list--item__link"
        >
          FAQ
        </router-link>
      </li>
    </ol>
    <h1 class="page-title">
      <span class="page-title-inner">FAQ</span>
    </h1>
    <p class="date-time">
      <time datetime="2021-03-05">{{ Question.dateTime[lang] }}</time>
    </p>
    <section
      class="faq"
      v-for="(item, itemIndex) in Question.items"
      :key="itemIndex"
    >
      <h2 class="subheading">{{ item.name[lang] }}</h2>
      <dl
        class="faq__list"
        v-for="(faq, faqIndex) in emptyRemoval(item.faqs)"
        :key="faqIndex"
      >
        <dt class="faq__list--question">{{ faq.question[lang] }}</dt>
        <dd class="faq__list--answer" v-html="faq.answer[lang]"></dd>
      </dl>
    </section>
  </main>
</template>

<script>
import Question from "../../../assets/constants/question/question.json";

export default {
  methods: {
    emptyRemoval: function (faqs) {
      return faqs.filter((faq) => faq.question[this.lang]);
    },
  },
  computed: {
    Question: function () {
      return Question;
    },
    lang: function () {
      return this.$store.state.lang;
    },
    langPath: function () {
      return this.$store.state.langPath;
    },
  },
  components: {
    Question,
  },
  name: "CommonQuestion",
};
</script>

<style scoped>
.main {
  .page-title {
    margin: 30px 0 0 0;
    line-height: 1.6;
    font-size: 50px;
    font-weight: 900;
    text-align: center;
    .page-title-inner {
      display: inline-block;
      &::after {
        content: "";
        display: block;
        height: 10px;
        background: url("../../../assets/images/border/border_faq.svg");
        background-size: 101%;
      }
    }
  }
  .date-time {
    margin: 60px 0 0 0;
    line-height: 1.5;
    text-align: right;
  }
  .faq {
    margin: 60px 0 0 0;
    &:first-of-type {
      margin: 25px 0 0 0;
    }
    .subheading {
      line-height: 1.33;
      font-size: 24px;
    }
    &__list {
      margin: 25px 0 0 0;
      padding: 0 0 25px 0;
      border-bottom: solid 1px var(--defaultBlackColor);
      &--question {
        min-height: 50px;
        line-height: 1.5;
        padding: 13px 0 0 70px;
        position: relative;
        &::before {
          content: "Q";
          padding: 0 13px;
          border: solid 2px var(--defaultBlackColor);
          border-radius: 50%;
          font-size: 32px;
          font-weight: bold;
          position: absolute;
          top: 0;
          left: 0;
        }
      }
      &--answer {
        min-height: 50px;
        margin: 10px 0 0 0;
        padding: 13px 0 0 70px;
        line-height: 1.5;
        white-space: pre-line;
        position: relative;
        &::before {
          content: "A";
          padding: 0 13px;
          border: solid 2px var(--blueFoundationColor);
          border-radius: 50%;
          font-size: 32px;
          font-weight: bold;
          color: var(--blueFoundationColor);
          position: absolute;
          top: 0;
          left: 0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sp/faq/CommonQuestion.vue